import IcRecordStart from "@/assets/svg/ic_record_start.svg?react";
import IcRecordPause from "@/assets/svg/ic_record_pause.svg?react";
import IcRecordPauseLoading from "@/assets/images/ic_record_pause_loading.png";
import IcRecordFinish from "@/assets/svg/ic_record_finish.svg?react";
import IcRecordFinishLoading from "@/assets/images/ic_record_finish_loading.png";
import timingStore, { RecordStatus } from "@/store/timing.store";
import MeetingHandler from "@/bussiness/MeetingHandler";
import { debounce } from "lodash";
import Tooltip from "@/component/Tooltip";
import recordStore from "@/store/record.store";
import { useEffect, useState } from "react";
import { handlePauseRecording, handleResumeRecording, handleStopRecording } from "@/utils/recordingHandler";
import { MAX_RECORD_TIME } from "@/constants";
import Dialog from "@/component/Dialog";
import CommonLoading from "@/component/CommonLoading";
import "./RecordOperator.less";

let timer: NodeJS.Timeout;

function RecordOperator() {

  const [showModal, setShowModal] = useState(false);
  const [showMaxRecordTimeDialog, setShowMaxRecordTimeDialog] = useState(false);

  const status = timingStore((state) => state.recordStatus);
  const isOnline = recordStore((state) => state.isOnline);
  const pauseOrResumeLoading = timingStore((state) => state.pauseOrResumeLoading);
  const finishLoading = timingStore((state) => state.finishLoading);

  const click = debounce(async () => {
    if (!isOnline) {
      return;
    }
    if (status === RecordStatus.FINISHED) return;

    if (status === RecordStatus.RECORDING) {
      handlePauseRecording();
    } else if (status === RecordStatus.PAUSED) {
      handleResumeRecording();
    }
  }, 300);

  // 每30s上报一次原文
  useEffect(() => {
    timer && clearInterval(timer);
    timer = setInterval(() => {
      try {
        MeetingHandler.saveDoc();
      } catch (error) {
        console.log('setInterval MeetingHandler.saveDoc error', error);
      }
    }, 30 * 1000);
    return () => {
      timer && clearInterval(timer);
    };
  }, []);

  useEffect(() => {
    const handleMaxRecordTime = async () => {
      setShowMaxRecordTimeDialog(true);
      await MeetingHandler.stopRecord();
    }
    const timingStoreSubscriber = timingStore.subscribe(
      (state) => state.recordTime,
      (state) => {
        if (state === MAX_RECORD_TIME) {
          handleMaxRecordTime();
        }
      }
    );

    return () => {
      timingStoreSubscriber && timingStoreSubscriber();
    }
  }, [])


  const handleClose = () => {
    handleStopRecording();
  };

  const handleCancel = () => {
    setShowModal(false);
  }

  const handleCancelMaxRecordTimeDialog = () => {
    setShowMaxRecordTimeDialog(false);
  }

  return (
    <div className={`flex`}>
      {status === RecordStatus.RECORDING ? (
        pauseOrResumeLoading ? (
          <CommonLoading src={IcRecordPauseLoading} className={`w-10 h-10 cursor-not-allowed`} />
        ) : (
          <Tooltip content="暂停录制" hover={true}>
            <IcRecordPause
              className={`w-10 h-10 ${isOnline ? "cursor-pointer" : "cursor-not-allowed"
                }`}
              onClick={click}
            />
          </Tooltip>
        )
      ) : (
        pauseOrResumeLoading ? (
          <CommonLoading src={IcRecordPauseLoading} className={`w-10 h-10 cursor-not-allowed`} />
        ) : (
          <Tooltip content="继续录制" hover={true}>
            <IcRecordStart className={`w-10 h-10 ${isOnline ? "cursor-pointer" : "cursor-not-allowed"}`} onClick={click} />
          </Tooltip>
        )
      )}
      <Tooltip content="结束录制" hover={true}>
        <IcRecordFinish
          className={`w-10 h-10 ${isOnline ? "cursor-pointer" : "cursor-not-allowed"
            } m-l-6`}
          onClick={() => {
            if (!isOnline) return;
            setShowModal(true);
          }}
        />
      </Tooltip>
      <Dialog
        isOpen={showModal}
        title={"确定结束会议录制吗？"}
        content={"确定结束后，无法继续录制"}
        confirmText={
          finishLoading ? (
            <div className="px-5 flex items-center cursor-not-allowed">
              <img src={IcRecordFinishLoading} className="rotation size-4" />
            </div>
          ) : (
            "结束录制"
          )
        }
        cancelText={
          <div className="px-2.75 flex items-center">
            取 消
          </div>
        }
        onConfirm={handleClose}
        onCancel={handleCancel}
      ></Dialog>
      <Dialog
        isOpen={showMaxRecordTimeDialog}
        title={"录制支持最长5小时，已超时"}
        content={""}
        confirmText={
          finishLoading ? (
            <div className="px-5 flex items-center cursor-not-allowed">
              <img src={IcRecordFinishLoading} className="rotation size-4" />
            </div>
          ) : (
            "结束录制"
          )
        }
        cancelText={
          <div className="px-2.75 flex items-center">
            取 消
          </div>
        }
        onConfirm={handleClose}
        onCancel={handleCancelMaxRecordTimeDialog}
      ></Dialog>
    </div>
  );
}

export default RecordOperator;
